module.exports = __webpack_public_path__ + "img/health.10df781b.jpg";